export default __webpack_public_path__ + "static/media/maisons_laffitte2.7da369a8.jpg";